import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { IOption } from "ng-select";
import { NgForm } from "@angular/forms";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HelperService } from "../../services/helper.service";
import { TosterMessageService } from "app/services/toster-message.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ConfigurationService } from "../../services/configuration.service";

@Component({
  selector: "app-objectives-edit-view-create-template-modal.component",
  templateUrl: "./objectives-edit-view-create-template-modal.component.html",
  providers: [ConfigurationService],
})
export class ObjectivesEditViewCreateTemplateComponent implements OnInit {
  public masterData: any = {};
  @Output() public ObjectiveRatingMasterReload: EventEmitter<any> =
    new EventEmitter<any>();

  formData = {
    main_element: "",
    main_proficiency: "",
  };

  isEdit: number;
  template_id: number;
  public items: Array<IOption> = [];
  auto_id: number;

//   public proficiencyListData: any = {};
//   public elementListData: any = {};

  elementListData: any[] = [];  
  proficiencyListData: any[] = [];


  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();
  // languageSystemID = +this.helperService.getAvailableLang();

  activeStatus = [
    { value: 0, label: "Not Active" },
    { value: 1, label: "Active" },
  ];

  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private configurationService: ConfigurationService,
    private tosterMessageService: TosterMessageService,
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
  }

  addNewRowToDetailTemplate(formData: any) {
    const requestData = {
      main_element: formData.main_element,
      main_proficiency: formData.main_proficiency,
      company_id: this.companySystemID,
      template_id: this.template_id,
    };
    console.log(requestData);
    let that = this;
    that.masterData.companySystemID = that.companySystemID;
    that.configurationService
      .addNewRowToDetailTemplate()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully added to detailed template";
          that.showSuccessHtml();
          this.ObjectiveRatingMasterReload.emit();
          that.closeModalAfterCreate();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
            this.ObjectiveRatingMasterReload.emit();
          }
          this.tosterMessageService.showError("Sorry", "No proof points found!");
        }
      );
    this.ObjectiveRatingMasterReload.emit();
  }


}



// WEBPACK FOOTER //
// /app/src/app/competancy/objectives-edit-view-create-template-modal/objectives-edit-view-create-template-modal.component.ts